import { ContentLibrary } from '@/components/contentLibrary';
import { ContentLibraryGate } from '@/components/contentLibrary/ContentLibraryGate';

export default function ContentLibraryRoute() {
  return (
    <ContentLibraryGate source="list">
      <ContentLibrary />
    </ContentLibraryGate>
  );
}
